import { WildNavigationType } from "../../../../../../data/enums/navigation_type";
import { FeaturesComponentListData } from "../../FeaturesData";

export const teamListDataShared: FeaturesComponentListData = {
  image: "https://firebasestorage.googleapis.com/v0/b/wild-live.appspot.com/o/v2%2Fimagesforbrochuresite%2Fteam%2Fdark-mode-team-calendar.png?alt=media&token=12744d73-2e80-4fb2-a999-d621f0ad0795",
  title: "Team Management",
  subtitle: "Role Based Team Management",
  page: WildNavigationType.TEAMMPAGE,
}